/**
 * Formats sub-program label, with a default of "division" if
 * there is no sub-program label provided.
 * @param subProgramLabel The label representing a sub-program.
 * @returns The `subProgramLabel` all lower case, or "division" if not defined.
 */
export const formatSubProgramLabel = (subProgramLabel) => {
    return (subProgramLabel === null || subProgramLabel === void 0 ? void 0 : subProgramLabel.toLowerCase().trim()) || 'division';
};
export const getSubProgramLabelPlural = (subProgramLabel) => {
    return subProgramLabel.endsWith('s')
        ? `${subProgramLabel}es`
        : `${subProgramLabel}s`;
};
